import { AutoMap } from "@automapper/classes";
import { Entity } from "../base/entity.model";

export class Status extends Entity {

    @AutoMap()
  public description!: string;

}